<template>
  <button
    class="inline-flex select-none items-center justify-center border border-ng70 bg-transparent px-4 py-[12px] tracking-[0.08em] hover:bg-ng20 focus:bg-ng100 disabled:opacity-60 disabled:hover:bg-transparent laptop:px-[40px] laptop:py-[19px]"
  >
    {{ $t("see-more") }}
    <Icon class="ml-4" name="simple-line-icons:arrow-down" />
  </button>
</template>

<script lang="ts" setup>
const { t: $t } = useI18n();
</script>
<style lang="scss" scoped></style>
